import React from 'react';
import { Link } from 'react-router-dom';
import DocumentTitle from 'react-document-title';
import { parseQuery } from '../../utils/tools';
import './style.less';

export default function Manage(props) {
    const queryObj = parseQuery(props.location.search.slice(1));
    // ac：爱课app  pd：爱课精品小班
    const appType = queryObj.apptype || 'ac'
    return <DocumentTitle title="账号管理">
        <div className="account-manage">
            <ul className="list">
                <Link className="item" to={`./logoff?appType=${appType}`}>账号注销</Link>
            </ul>
        </div>
    </DocumentTitle>
}


// WEBPACK FOOTER //
// ./src/components/account/manage.jsx